// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as AddTableExtended } from '../../../assets/icons/extended/custom3.0/add-table.svg?react';
import { createIcons } from '../../Icon';
const AddTableIcon = /* @__PURE__ */ createIcons('AddTable', {
    extended: AddTableExtended
});
AddTableIcon.supportedTypes = ['extended'];
AddTableIcon.category = 'custom3.0';
export default AddTableIcon;
